module.exports = __webpack_public_path__ + "static/media/Shop_VIP_Divider@3x.ecc3c5fa.png";